import Head from 'next/head'
import Layout, { Breadcrumb } from 'components/layout'
import { Container } from 'components/ui'
import type { ReactNode } from 'react'
import s from './perguntas-frequentes.module.css'

interface ItemProps {
  id: string
  title: string
  content: ReactNode
}

const Item = ({ title, content }: Omit<ItemProps, 'id'>) => {
  return (
    <>
      <h3 className={s.title}>{title}</h3>
      <div className={s.content}>{content}</div>
    </>
  )
}

export default function PerguntasFrequentes() {
  const QA: Array<ItemProps> = [
    {
      id: 'como-faco',
      title: 'Como faço para recuperar minha senha na Fazendinha?',
      content: (
        <>
          <p>
            Para recuperar sua senha clique em&nbsp;<strong>“Entrar”</strong>&nbsp;e depois em&nbsp;
            <strong>“Esqueceu a senha?”.</strong>&nbsp;Em seguida&nbsp;<strong>coloque seu e-mail</strong>&nbsp;e
            enviaremos o passo a passo para criar uma nova senha no e-mail cadastrado.
          </p>
        </>
      ),
    },
    {
      id: 'o que devo',
      title: 'O que devo saber sobre o prazo de entrega?',
      content: (
        <>
          <p>
            O prazo varia de acordo com o local e o método de entrega escolhidos no ato da compra, lembrando que o prazo
            será contado a partir do próximo dia útil seguinte da liberação do pagamento do pedido.
          </p>
          <p>
            Você receberá um e-mail com a confirmação da sua compra juntamente com o prazo de entrega selecionado para o
            método de envio selecionado no ato da compra. Para acompanhar o status do seu pedido, acesse o seu cadastro
            e clique no item “Meus Pedidos”.
          </p>
        </>
      ),
    },
    {
      id: 'entrega',
      title: 'O que verificar no ato da entrega?',
      content: (
        <>
          <p>
            Trabalhamos para garantir que seu pedido seja entregue com todo cuidado, porém é de extrema importância
            adotar alguns cuidados no ato do recebimento do pedido:
          </p>
          <p>
            <strong>
              Confira o conteúdo na presença do entregador; verifique se a embalagem não está violada; verifique se os
              produtos estão de acordo com o pedido realizado.
            </strong>
          </p>
          <p>
            Caso ocorra alguma divergência do conteúdo, recuse a entrega e comunique imediatamente a Fazendinha, através
            de nossa Central de Relacionamento, basta enviar uma mensagem{' '}
            <strong>
              <a href="https://fazendinha.me/contato/">clicando aqui</a>.
            </strong>
          </p>
        </>
      ),
    },
    {
      id: 'regioes',
      title: 'Em quais regiões o Fazendinha entrega?',
      content: (
        <>
          <p>
            A entrega dos produtos varia de acordo com o produtor, ou seja, cada produtor define se seus produtos são
            entregues em apenas em sua região ou em todo o Brasil.
          </p>
          <p>
            Para verificar a disponibilidade adicione os produtos que deseja em seu{' '}
            <a href="https://fazendinha.me/carrinho/">carrinho</a> e realize uma simulação de frete, assim você saberá a
            disponibilidade de entrega de cada produtor para o seu endereço.
          </p>
          <p>
            Na página de cada produto também você encontrará a informação se o produto tem entrega local ou nacional.
          </p>
        </>
      ),
    },
    {
      id: 'quero-vender',
      title: 'Quero vender no Fazendinha, como faço?',
      content: (
        <>
          <p>
            Se você é um pequeno produtor e quer expandir as suas vendas para outras regiões ou para todo o Brasil,
            basta preencher o{' '}
            <strong>
              <a href="https://fazendinha.me/seja-um-vendedor/">formulário de cadastro de vendedor</a>
            </strong>{' '}
            e aguardar o nosso contato.
          </p>
          <p>Nós te explicaremos tudo o que você precisa saber para vender seus produtos em nossa loja.</p>
        </>
      ),
    },
    {
      id: 'duvidas',
      title: 'Não encontrei minha dúvida, tenho sugestões ou reclamações',
      content: (
        <>
          <p>
            Você pode nos enviar um e-mail a qualquer momento explicando tudo o que precisa{' '}
            <a href="https://fazendinha.me/contato/">
              <strong>clicando aqui</strong>
            </a>
            . Será um enorme prazer te ouvir e poder te ajudar!
          </p>
        </>
      ),
    },
  ]

  const crumbs = [
    {
      label: 'Institucional',
    },
  ]

  return (
    <Layout>
      <Head>
        <title>Perguntas Frequentes</title>
      </Head>
      <Breadcrumb crumbs={crumbs} />
      <Container className={s.root}>
        <h1 className={s.page}>Perguntas Frequentes</h1>
        <div>
          {QA.map(({ id, ...item }) => (
            <Item key={`qa-item-${id}`} {...item} />
          ))}
        </div>
      </Container>
    </Layout>
  )
}
